import { Injectable } from '@nestjs/common';

@Injectable()
export class ForkLiftItemsService {}
